import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/marketing/Header";
import api from "@/lib/api";
import { Mail, Phone, MapPin, Clock3 } from "lucide-react";

export default function MarketingFooter() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  const c = content?.contact || {};

  return (
    <footer className="bg-[#0a2540] text-white">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <Logo light />
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
            On-demand professional interpretation over crystal-clear voice. Any language, any hour.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-white/80 hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/services" className="text-white/80 hover:text-white transition-colors">Our Services</Link></li>
            <li><Link to="/news" className="text-white/80 hover:text-white transition-colors">News</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact Us</Link></li>
            <li><Link to="/interpreter-login" className="text-white/80 hover:text-white transition-colors">Interpreter Login</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-teal-400" /> {c.email || "—"}</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-teal-400" /> {c.phone || "—"}</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-teal-400" /> {c.address || "—"}</li>
            <li className="flex items-center gap-2"><Clock3 className="h-4 w-4 text-teal-400" /> {c.hours || "—"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-white/40 flex justify-between">
          <span>© {new Date().getFullYear()} Interpreta. All rights reserved.</span>
          <span>Interpretation, on demand.</span>
        </div>
      </div>
    </footer>
  );
}
